import React, { useEffect } from 'react';
import styles from './itemCard.module.scss';
import { IMenuItemResponce } from '../../../../../../../../Interfaces/responseTypes';
import useLanguagesHooks from '../../../../../../../../Components/Languages/setLanguage-hooks';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import Button from '../../../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../../../Interfaces/componentTypes';
import { PlusIcon } from '../../../../../../../../Assets/Icons';

interface IProps {
    data: IMenuItemResponce;
    onClick: () => void;
    currencySymbol: string;
}

const ItemCard = React.forwardRef<HTMLDivElement, IProps>(({ data, currencySymbol, onClick }, ref) => {
    const { t, activeLanguage } = useLanguagesHooks();
    const { baseURL, renderOptions } = useNoAuthHooks();
    const localizedTitle = data[`name_${activeLanguage}` as keyof IMenuItemResponce] || data.name_en;
    const mainOption = data.option.filter((option) => option.is_active === true)[0];

    return (
        <>
            {
                mainOption
                &&
                <div className={styles.card} onClick={onClick} ref={ref}>
                    <img src={`${baseURL}${data.image}`} alt={`${data.image}.png`} className={styles.image} />
                    <div className={styles.itemInfo}>
                        <div className={styles.price}>
                            <p>{parseInt(mainOption.price!)}</p>
                            <p>{currencySymbol}</p>
                        </div>
                        <div className={styles.title}>
                              <p>{String(localizedTitle).length > 18 ? String(localizedTitle).slice(0, 18) + "..." : String(localizedTitle)}</p>
                        </div>
                        <div className={styles.option}>
                            <p>{renderOptions(mainOption)}</p>
                        </div>
                    </div>
                    <Button
                        buttonType={ButtonTypes.Primery}
                        leftIcon={PlusIcon}
                        title={t('Buttons.Add')}
                        onClick={onClick}
                        buttonStyle={styles.addButton}
                    />
                </div>
            }
        </>

    );
});

ItemCard.displayName = 'ItemCard'; // To avoid warnings in development mode

export default ItemCard;
